export const onRequest = (type) => [type, '[REQUEST]'].join(' ');
export const onSuccess = (type) => [type, '[SUCCESS]'].join(' ');
export const onFailure = (type) => [type, '[FAILURE]'].join(' ');
export const withNamespace = (type, namespace) => [namespace, type].join(' / ');
